import { ColumnMatcherTypes } from "../../types/rules/ColumnMatcherTypes";
import { DlfMatcherTypes } from "../../types/rules/DlfMatcherTypes";
import { MatcherTypes } from "../../types/rules/MatcherTypes";

export { Matcher, MatcherProperties };

type MatcherProperties = {
  reusable: boolean;
  position: number;
  threshold: number;
  discriminator: MatcherTypes;
};

abstract class Matcher {
  // TODO: remove reusable from here
  abstract reusable: boolean;
  abstract position: number;
  abstract discriminator: MatcherTypes;
  abstract threshold: number;

  /**
   * The unique value between all Matcher types
   */
  abstract getMatcherId(): string;

  abstract getDiscriminator(): MatcherTypes;

  abstract isConfigured(): boolean;
  abstract clear(): void;

  toggleReusable(): boolean {
    this.setReusable(!this.getReusable());
    return this.getReusable();
  }
  getReusable(): boolean {
    return this.reusable;
  }
  setReusable(value: boolean): void {
    this.reusable = value;
  }

  supportsAllowEmpty(): boolean {
    return false;
  }

  abstract toMatcherData(): MatcherProperties;
}
